var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-index"},[_c('tracking'),_vm._v(" "),_c('input-shipping-check-price',{staticClass:"cek-tariff",on:{"click":_vm.goingToTrack}}),_vm._v(" "),_c('location-agent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }